import { META_INFO_KEYS, VIDEO_FORMAT_KEY } from '@core/constants/ACTIVES';

/**
 * Check if the item is a video item.
 * @param {string} img_zoom - The image zoom
 * @returns {boolean}
 */
export const isVideoItem = (img_zoom) => {
    return img_zoom && img_zoom.includes(VIDEO_FORMAT_KEY);
};

/**
 * Get the keys of the meta info param.
 * @param {string} value - The value of the meta info param.
 * @returns {Array<string>} - The keys of the meta info param.
 */
export const handleMetaInfoParam = (value) => {
    const /** @type {Array<string>} */ keys = [];
    value = value.toLowerCase();

    if (value.includes(META_INFO_KEYS.AI) || value.includes(META_INFO_KEYS.IA)) {
        keys.push(META_INFO_KEYS.AI);
    }

    if (value.includes(META_INFO_KEYS.EXCLUSIVE || META_INFO_KEYS.EXCLUSIVO)) {
        keys.push(META_INFO_KEYS.EXCLUSIVE);
    }

    if (value.includes(META_INFO_KEYS.PREMIUM)) {
        keys.push(META_INFO_KEYS.PREMIUM);
    }

    return keys;
};
